import type { RootState } from "../store";

export const selectIsAutosaveBlocked = (state: RootState): boolean => {
  const entry = state.entrySlice;
  const gen = state.generatorSlice;
  const features = state.generatorFeaturesSlice;

  return (
    entry.openedSaveModal ||
    entry.openedRefetchModal ||
    entry.autosaveSuspendCount > 0 ||
    gen.checkListsModalProps.opened ||
    gen.stampsModalProps.opened ||
    Boolean(features.ilModalData) ||
    Boolean(features.deisolatedTimeModalData) ||
    Boolean(features.timeInputPopup) ||
    Boolean(features.NMEAModalData?.opened) ||
    Boolean(features.unitConverterModalData)
  );
};
